import { MessageCircle } from "lucide-react";
import { Reveal, Stagger, StaggerItem } from "@/components/site/Reveal";
import { HOW_IT_WORKS } from "@/data/content";
import { whatsappLink } from "@/config/site";
import { track } from "@/lib/analytics";

export const HowItWorks = () => (
  <section id="how-it-works" className="relative overflow-hidden bg-slate-950 py-20 text-white sm:py-28" data-testid="how-it-works-section">
    <div className="grain absolute inset-0" />
    <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <Reveal>
        <p className="text-sm font-bold uppercase tracking-widest text-emerald-400">Simple process</p>
        <h2 className="mt-3 font-display text-4xl font-black tracking-tight text-white sm:text-5xl">
          How It Works
        </h2>
      </Reveal>

      <Stagger className="mt-14 grid gap-8 sm:grid-cols-2 lg:grid-cols-4">
        {HOW_IT_WORKS.map((step) => (
          <StaggerItem key={step.n}>
            <div className="relative" data-testid={`step-${step.n}`}>
              <span className="font-display text-7xl font-black text-white/10">{step.n}</span>
              <h3 className="mt-2 font-display text-xl font-bold text-white">{step.title}</h3>
              <p className="mt-2 text-slate-400">{step.text}</p>
            </div>
          </StaggerItem>
        ))}
      </Stagger>

      <Reveal delay={0.1}>
        <div className="mt-12">
          <a
            href={whatsappLink()} onClick={() => track.whatsappClick("how-it-works")}
            target="_blank" rel="noreferrer" data-testid="how-whatsapp-cta"
            className="inline-flex items-center gap-2 rounded-full bg-[#25D366] px-8 py-4 text-base font-bold text-white transition-transform hover:scale-105"
          >
            <MessageCircle size={18} /> Start on WhatsApp
          </a>
        </div>
      </Reveal>
    </div>
  </section>
);
